import { UserRole } from 'src/appConfig/sidebar';
import { isEmpty } from '.';

export const hasPagePermission = (userRole: UserRole, pagePermissions?: UserRole[]) => {
  if (!pagePermissions) return true;
  if (isEmpty(pagePermissions)) return true;
  return pagePermissions.some(permission => userRole.includes(permission));
};
